import { useRef } from 'react';
import { showGlobalAlert } from './globalAlert';

export const useAlert = (externalMessageRef = null) => {
  const messagerRef = useRef(externalMessageRef || null);
  const showAlert = (title, icon, msg) => showGlobalAlert(icon, title, msg);
  return { messagerRef, showAlert };
};
